























import { getRange } from '@/libs/time';
import CronjobServices from '@/services/cronjob';
import DatajobServices from '@/services/datajob';
import { Vue, Component, Watch } from 'vue-property-decorator';
@Component
export default class Job1 extends Vue {
  bread = [{ name: '作业运行管理' }, { name: '作业运行总览' }];
  jobSrv = new CronjobServices();
  datajobSrv = new DatajobServices();

  columns = [
    { title: '作业处理数据日期', dataIndex: 'data_date' },
    { title: '作业总数', dataIndex: 'total' },
    {
      title: '作业最终执行状态',
      children: [
        { title: '未处理', dataIndex: 'totalStatus0' },
        { title: '处理中', dataIndex: 'totalStatus1' },
        { title: '处理成功', dataIndex: 'totalStatus2' },
        { title: '处理失败', dataIndex: 'totalStatus3' }
      ]
    },
    {
      title: '作业执行信息',
      children: [
        { title: '作业失败次数', dataIndex: 'totalRecordStatus3' },
        { title: '作业重跑次数', dataIndex: 'totalRecordType2' },
        { title: '作业补跑次数', dataIndex: 'totalRecordType3' }
      ]
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 90,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  created() {
    this.getList();
  }

  date: any = getRange('week');
  list: any[] = [];
  async getList() {
    let [startTime, endTime] = this.date;
    let joblist = await this.jobSrv.getTotalRecord({ startTime, endTime });
    let datalist = await this.datajobSrv.getTotalRecord({ startTime, endTime });

    let dateSet = new Set();
    for (let item of joblist) {
        dateSet.add(item.data_date);
    }
    for (let item of datalist) {
        dateSet.add(item.data_date);
    }

    dateSet.forEach((v) => {
      let item1 = joblist.filter((item: any) => item.data_date === v);
      let item2 = datalist.filter((item: any) => item.data_date === v);
      if (item1.length > 0 && item2.length > 0) {
          this.list.push({
            data_date: item1[0].data_date,
            total: item1[0].total + item2[0].total,
            totalStatus0: item1[0].totalStatus0 + item2[0].totalStatus0,
            totalStatus1: item1[0].totalStatus1 + item2[0].totalStatus1,
            totalStatus2: item1[0].totalStatus2 + item2[0].totalStatus2,
            totalStatus3: item1[0].totalStatus3 + item2[0].totalStatus3,
            totalRecordStatus3: item1[0].totalStatus3 + item2[0].totalRecordStatus3,
            totalRecordType2: item1[0].totalStatus3 + item2[0].totalRecordType2,
            totalRecordType3: item1[0].totalStatus3 + item2[0].totalRecordType3,
          });
      } else if (item1.length > 0 && item2.length == 0) {
        this.list.push(item1[0]);
      } else if (item1.length == 0 && item2.length > 0) {
        this.list.push(item2[0]);
      }
    });
  }

  @Watch('date')
  onDateChange() {
    this.getList();
  }

  routeTo(record: any) {
    return {
      path: '/jobs/record/group',
      query: {
        startTime: record.data_date,
        endTime: record.data_date
      }
    };
  }
}
